import { render, staticRenderFns } from "./NotAuthorizedPage.vue?vue&type=template&id=04f23bdc&scoped=true"
import script from "./NotAuthorizedPage.vue?vue&type=script&lang=js"
export * from "./NotAuthorizedPage.vue?vue&type=script&lang=js"
import style0 from "./NotAuthorizedPage.vue?vue&type=style&index=0&id=04f23bdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f23bdc",
  null
  
)

export default component.exports